import { useEffect, useState } from "react";
import {
  CustomButton,
  CustomTextField,
  NavigateBack,
} from "../../../components";
import { Heading } from "../../appSettings/AppSettingsStyles";
import { Notify } from "../../../utils";
import { Constant } from "../../../config";
import { RoleService } from "../../../_service";
import { useLocation, useNavigate } from "react-router-dom";

const AddGroup = () => {
  const [groupName, setGroupName] = useState<string>("");
  const [groupDescription, setGroupDescription] = useState<string>("");

  const navigate = useNavigate();
  const location = useLocation();

  const addGroup = async () => {
    try {
      const { status } = await RoleService._addRole(groupName,groupDescription);
      if (status === 201) {
        Notify("Group Added Successfully", 1);
        navigate("/dashboard/manage-users/groups");
      }
    } catch (error: any) {
      // console.log('groupErr', error)
      Notify(error?.response?.data?.error[0], 0);

    }
  };

  const editGroup = async () => {
    try {
      const { status } = await RoleService._editRole(
        location.state.id,
        groupName,
        groupDescription
      );
      if (status === 200) {
        Notify("Group edited Successfully", 1);
        navigate("/dashboard/manage-users/groups");
      }
    } catch (error) {
      Notify(Constant.common.something_went_wrong, 0);
    }
  };

  const saveButtonClick = () => {
    if (location.pathname.split("/").pop() === "edit") {
      editGroup();
    } else {
      addGroup();
    }
  };

  useEffect(() => {
    if (location.pathname.split("/").pop() === "edit") {
      setGroupName(() => location.state.name);
      setGroupDescription(()=> location.state.description)
    }
  }, []);
  return (
    <div>
      <NavigateBack />
      <Heading>Add Group</Heading>
      <div style={{ margin: "40px 16px" }}>
        <CustomTextField
          title="Group Code"
          value={groupName}
          onChangeText={setGroupName}
        />
        <CustomTextField
          title="Group Description"
          value={groupDescription}
          onChangeText={setGroupDescription}
        />
      </div>
      <CustomButton
        title="Save"
        onClick={saveButtonClick}
        disable={groupName.length <= 0}
      />
    </div>
  );
};

export default AddGroup;
